export const SAAS_APP_URL = (
  import.meta.env.VITE_SAAS_APP_URL || "https://app.emite.do"
).replace(/\/$/, "");

export function saasAppUrl(path = ""): string {
  if (!path) {
    return SAAS_APP_URL;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SAAS_APP_URL}${normalized}`;
}

export function saasSignInUrl(): string {
  return saasAppUrl("/sign-in");
}
